import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  Typography,
  Row,
  Col,
  message,
} from "antd";
import { piopiy, piopiyDialUser } from "../../../../../utils/piopiy";
import { platformApi } from "../../../../../api";
import { getUUID } from "../../../../../_helpers/utils";

const { Title } = Typography;

const FeedbackCallModal = ({ form, open, close, data }) => {
  const { getFieldDecorator, validateFields, setFieldsValue } = form;
  const telecmiUser = localStorage.getItem("selectedTelecmiUserId");
  const [loading, setLoading] = useState(false);
  const [callPlaced, setCallPlaced] = useState(false);

  // Monitor and clean customer feedback in real-time
  useEffect(() => {
    const customerFeedback = form.getFieldValue('customerFeedback');
    if (customerFeedback) {
      const cleanValue = customerFeedback.replace(/[^a-zA-Z0-9\s]/g, '');
      if (cleanValue !== customerFeedback) {
        setFieldsValue({ customerFeedback: cleanValue });
      }
    }
  }, [form.getFieldValue('customerFeedback')]);

  // Autofill feedback if view mode
  useEffect(() => {
    if (data?.view && data?.customerFeedback) {
      setFieldsValue({ customerFeedback: data.customerFeedback });
    }
  }, [data]);

  const handleCall = () => {
    if (!telecmiUser) {
      message.error("Can't place call, login to TeleCMI account to continue.");
      return;
    }

    if (!(data?.customerPhone && data?.id)) {
      message.error("Customer phone not found.");
      return;
    }

    setLoading(true);
    if (data.booking) {
      const uuid = getUUID();
      setCallPlaced(true);
      const mobileNumber = "91" + data.customerPhone;
      piopiyDialUser(piopiy, mobileNumber, uuid, "Sale Register Feedback", data.salesId);

    } else {
      const jobData = {
        jobOrder: data.id,
        event: "Feedback Outgoing Call",
      };

      platformApi
        .post("/api/jobOrderlog", jobData)
        .then((res) => {
          const { data: resData } = res;
          if (resData.code === 200) {
            const uuid = resData?.response?.data?.id;
            const mobileNumber = "91" + data.customerPhone;
            setCallPlaced(true);
            piopiyDialUser(
              piopiy,
              mobileNumber,
              uuid,
              "Job-Order Feedback",
              data.id
            );
          } else {
            message.error("Error placing call");
          }
        })
        .catch(() => {
          message.error("Error placing call");
        })
        .finally(() => setLoading(false));
    }
  };

  const handleSubmit = () => {
    if (!callPlaced) {
      message.error("You must place a call before submitting feedback.");
      return;
    }

    validateFields((err, values) => {
      if (err) return;

      const payload = {
        id: data.booking ? data.salesId : data.id,
        customerFeedback: values.customerFeedback,
      };

      if(data.booking){
        platformApi.post("/api/saleRegister/saveFeedback", payload).then((res)=>{
          message.success("Feedback Submitted Successfully");
          close();
        }).catch(()=>{
          message.error("Error Saving Feedback")
        })
      } else {
        platformApi
        .post("/api/jobOrder/saveFeedback", payload)
        .then(() => {
          message.success("Feedback submitted successfully");
          close();
        })
        .catch(() => {
          message.error("Error saving feedback");
        });
      }
    });
  };

  return (
    <Modal
      title={<Title level={4}>Feedback Call: {data?.jobNo}</Title>}
      visible={open}
      onCancel={close}
      okText="Save"
      onOk={handleSubmit}
      okButtonProps={{
        style: { display: data?.view ? "none" : "inline-block" },
      }}
      width={"600px"}
    >
      <Form layout="vertical">
        <Form.Item label="Customer">
          <Row gutter={8} align="middle">
            <Col span={14}>
              <Input
                value={
                  `${data?.customer?.name || ""} - ${
                    data?.customerPhone || ""
                  }` || "N/A"
                }
                disabled
              />
            </Col>

            {!data?.view && (
              <Col span={10}>
                <Button
                  type="primary"
                  icon="phone"
                  block
                  onClick={handleCall}
                  disabled={loading}
                  style={{ height: "30px" }}
                >
                  Call {data?.customer?.name || ""}
                </Button>
              </Col>
            )}
          </Row>
        </Form.Item>

        <Form.Item label="Customer Feedback">
          {getFieldDecorator("customerFeedback", {
            rules: [
              {
                required: !data?.view,
                message: "Please enter customer feedback",
              },
            ],
          })(
            <Input.TextArea
              rows={3}
              placeholder="Type feedback from customer..."
              disabled={!!data?.view}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const WrappedFeedbackCallModal = Form.create({ name: "feedback_call" })(
  FeedbackCallModal
);
export default WrappedFeedbackCallModal;
